module.exports = __webpack_public_path__ + "02ef4c1e156826b5aefe20e87d74a721.pdf";